<div class="row g-0 screen-height pb-5">

  <div class="col-7 d-none d-lg-block public-hero-clip">

    <img class="public_hero_bg" src="assets/img/public_background.jpg">
    <img class="public_hero_image" src="assets/img/public_hands.png">

    <div class="public_hero_nav text-white">
      <app-nav></app-nav>
    </div>

    <div class="public_hero_logo">
      <img class="hero-logo" src="assets/svg/mn_logo_white.svg">
    </div>

  </div>

  <nav class="d-block d-lg-none navbar navbar-dark bg-primary mb-5">

    <div class="container-fluid px-5">
      <div class="navbar-item">
        <a class="text-white text-decoration-none" routerLink="/register" href="#"><i class="fa fa-user-plus" aria-hidden="true"></i> Registrace</a>
        <a class="text-white text-decoration-none ms-3" routerLink="/login" href="#"><i class="fa fa-sign-in" aria-hidden="true"></i> Přihlášení</a>
      </div>
    </div>

  </nav>

  <div class="col-12 col-lg-5">

    <router-outlet></router-outlet>

  </div>

</div>

<div class="footer bg-primary text-white">
  Hematologicko-transfuzní oddělení | Městská nemocnice Čáslav | <a class="text-white text-decoration-none" href="/page/privacy-policy"> Zpracování osobních údajů</a> | <a class="text-white text-decoration-none" data-bs-toggle="modal" data-bs-target="#exampleModal"> <i class="fa fa-support"></i> Podpora</a>
</div>

<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Podpora</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        Svůj dotaz či hlášení prosím směřujte na email support@techcrowd.cz
      </div>
      <div class="modal-footer">
        <a href="mailto:support@techcrowd.cz" class="btn btn-primary">Napsat email</a>
      </div>
    </div>
  </div>
</div>
